import { useContext, useMemo } from 'react'

import { ChooseFrequencyLaterContext } from './choose-frequency-later-context'

export function useChooseOfferFrequencyLaterContext() {
  const context = useContext(ChooseFrequencyLaterContext)

  if (!context) {
    throw new Error(
      'useChooseOfferFrequencyLaterContext should be used with a ChooseFrequencyLaterContextProvider'
    )
  }

  const contextValues = useMemo(() => context, [context])

  return contextValues
}
